import type { Path } from 'react-router';
// eslint-disable-next-line no-restricted-imports
import { createSearchParams, matchPath } from 'react-router';

import { projectContextSchema } from './projectContext';

export function readProjectContextFromPath(path: Path) {
  const match = matchPath('/projects/:projectKey/*', path.pathname);

  if (!match) {
    return undefined;
  }

  const projectKey = match?.params.projectKey;

  if (!projectKey) {
    return undefined;
  }

  const searchParams = createSearchParams(path.search);
  const environmentKeys = new Set(searchParams.getAll('env'));
  const selectedEnvironmentKey = searchParams.get('selected-env') ?? '';
  const selectedViewKey = searchParams.get('selected-view') ?? undefined;

  const params = { projectKey, environmentKeys, selectedEnvironmentKey, selectedViewKey };
  const result = projectContextSchema.safeParse(params);

  if (!result.success) {
    return undefined;
  }

  return result.data;
}
